import { redirect, type LoaderFunctionArgs } from 'react-router-dom';
import { withWorkspace } from '@immo/api-contract';
import { FORBIDDEN_CODE, ForbiddenError } from '@/lib/errors/api-error';
import { loadWorkspaceShell } from '@/lib/auth/workspace-context';
import { nonRouteRules } from '@/lib/permissions/non-route-rules';
import { mayCall } from '@/lib/permissions/route-gate';
import { HLRE_AREA_PAGES } from './area-pages';

export async function hlreAreaLoader({ params }: LoaderFunctionArgs): Promise<null> {
  const shell = await loadWorkspaceShell(params.workspaceId);

  if (!mayCall(shell.permissions, nonRouteRules.hlreArea)) throw new ForbiddenError({ code: FORBIDDEN_CODE });

  const first = HLRE_AREA_PAGES.find((page) => mayCall(shell.permissions, page.gate));

  if (first !== undefined) throw redirect(first.to(withWorkspace(shell.workspaceSlug)));

  return null;
}
